import React, { memo } from "react";

import { DeliverySpeedPriceBlock } from "@swiggy-private/cart-types";
import { DELIVERY_SPEED_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { isEmpty } from "@swiggy-private/js-utils";

import { PriceBlockWrapper, StrikeOffText, FinalText, FreeDeliveryText } from "./PriceBlock.style";

interface PriceBlockProps {
    priceInfo: DeliverySpeedPriceBlock;
}

export const FREE_TEXT = "FREE";

function PriceBlock({ priceInfo }: PriceBlockProps) {
    const {
        strike_off_text: strikeOffText,
        final_text: finalText,
        is_free_delivery_applicable: isFreeDeliveryApplicable,
    } = priceInfo;

    if (isEmpty(strikeOffText) && isEmpty(finalText)) {
        return null;
    }

    return (
        <PriceBlockWrapper data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_PRICE_BLOCK}>
            {!isEmpty(strikeOffText) && (
                <StrikeOffText
                    data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_PRICE_STRIKE}
                    variant="V2.body2.neutral.medium"
                    color="text_Med_Emphasis"
                >
                    {strikeOffText}
                </StrikeOffText>
            )}
            {!isEmpty(finalText) && (
                <FinalText
                    data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_PRICE_FINAL}
                    variant="V2.body2.neutral.medium"
                    color={"text_High_Emphasis"}
                >
                    {finalText}
                </FinalText>
            )}
            {isFreeDeliveryApplicable && (
                <FreeDeliveryText
                    data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_PRICE_FREE}
                    variant="V2.body2.neutral.medium"
                    color="special_positive"
                >
                    {FREE_TEXT}
                </FreeDeliveryText>
            )}
        </PriceBlockWrapper>
    );
}

export default memo(PriceBlock);
